import Language from "../../language.js";
const lang = new Language();

export default `<div class="layercrop">
		<div class="layercrop-wrap">
			<div class="layercrop-main">
				<span class="layercrop-close btn-close fz-20">
					<svg class="icon" aria-hidden="true">
						<use xlink:href="#icon-close"></use>
					</svg>
				</span>
				<div class="layercrop-header">
					<h3 class="fz-16">` +
	lang.imageCropping +
	`</h3>
				</div>
				<div class="layercrop-body">
					<div class="layercropb-left">
						<div class="layercropb-imgbox"></div>
						<div class="layercropb-handle text-center">
							<button class="btn-lchandle btn-rotate-left fz-16">
								<svg class="icon" aria-hidden="true">
									<use xlink:href="#icon-rotate-left"></use>
								</svg>
							</button>
							<button class="btn-lchandle btn-rotate-right fz-16">
								<svg class="icon" aria-hidden="true">
									<use xlink:href="#icon-rotate-right"></use>
								</svg>
							</button>
							<button class="btn-lchandle btn-zoom-in fz-16">
								<svg class="icon" aria-hidden="true">
									<use xlink:href="#icon-zoom-in"></use>
								</svg>
							</button>
							<button class="btn-lchandle btn-zoom-out fz-16">
								<svg class="icon" aria-hidden="true">
									<use xlink:href="#icon-zoom-out"></use>
								</svg>
							</button>
							<button class="btn-lchandle btn-reset fz-16">
								<svg class="icon" aria-hidden="true">
									<use xlink:href="#icon-reset"></use>
								</svg>
							</button>
						</div>
					</div>
					<div class="layercropb-right">
						<h3 class="fz-14 text-center">` +
	lang.cropPreview +
	`</h3>
						<div class="previewBox"></div>
					</div>
				</div>
				<div class="layercrop-footer">
					<button type="button" class="layercrop-btn cancel fz-16 btn-close">` +
	lang.btnCancel +
	`</button>
					<button type="button" class="layercrop-btn done fz-16 btn-done">` +
	lang.btnConfirm +
	`</button>
				</div>
				
			</div>
		</div>
	</div>`;
